import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useDeleteServiceMutation, useGetAllServicesQuery } from "../../../../redux/service/vendorService";
import VendorServiceView from "./VendorServiceView";


const VendorServiceViewWrapper = () => {
  const [services, setServices] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const { data, isLoading, isFetching } = useGetAllServicesQuery();
  const [deleteService] = useDeleteServiceMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setServices(data?.data);
    }
  }, [data, isLoading, isFetching]);
  //   const { vendorId } = useParams();

  const handleAddService = (serviceData) => {
    const newService = {
      id: services.length + 1,
      ...serviceData,
    };
    setServices([...services, newService]);
    setIsFormOpen(false);
    toast.success("Service added successfully");
  };

  const handleEditService = (serviceData) => {
    if (!editingService) return;
    setServices(
      services.map((service) =>
        service.id === editingService.id
          ? { ...service, ...serviceData }
          : service
      )
    );
    setEditingService(null);
    setIsFormOpen(false);
    toast.success("Service updated successfully");
  };

  const handleDeleteService = async (id) => {
    toast.promise(deleteService(id).unwrap(), {
      loading: "Deleting service...",
      success: () => {
        return "Service deleted successfully";
      },
      error: "Failed to delete service",
    });
  };

  return (
   <div className="m-2">
     <VendorServiceView
      isFormOpen={isFormOpen}
      isServiceLoading={isLoading || isFetching}
      setIsFormOpen={setIsFormOpen}
      editingService={editingService}
      setEditingService={setEditingService}
      vendorServices={services}
      handleAddService={handleAddService}
      handleEditService={handleEditService}
      handleDeleteService={handleDeleteService}
    />
   </div>
  );
};

export default VendorServiceViewWrapper;